module.exports = __webpack_public_path__ + "img/hubbel.e1fb966e.png";